// "Enviar para o My Planner" de uma lista de valores inteira (Texto 3, C2): cobranças da turma, contas a pagar e a
// receber de Finanças, recebimentos de "Onde trabalho", parcelas, reservas... Enviada, a lista toda aparece na
// caixinha da aba no My Planner, inclusive o que for criado depois; "Tirar do My Planner" desliga (nada é apagado).
// Lista não enviada não aparece no My Planner (C1).
import { setDoc, useDoc } from '../store/store';
import type { AbaId, Ajustes } from '../store/types';
import type { Colecao } from '../modulos/tipos';

/** Em Finanças, a lista de contas do mês (a pagar, a receber e faturas do cartão) vai inteira. */
export const LISTA_CONTAS = 'contas';

/** Lista de valores que pode ir para o My Planner: tem valor em dinheiro, marca de pago/recebido e data com aviso. */
export function listaDeValores(col: Colecao) {
  if (!col.check || !col.campos.some(f => f.t === 'dinheiro') || !col.campos.some(f => f.t === 'data' && !!f.aviso?.length)) return false;
  const marca = col.campos.find(f => f.k === col.check);
  return col.check === 'pago' || marca?.seg === 'fin';   // "Recebido" de dinheiro (não a entrega de material da obra)
}

/** Lista com data e aviso (vacinas, IPVA, roteiro, devoluções...): também só vai ao My Planner quando enviada (C1). */
export function listaComData(col: Colecao) {
  return col.campos.some(f => f.t === 'data' && !!f.aviso?.length);
}
/** Documentos e Garantias (abas próprias): a lista inteira usa esta chave. */
export const LISTA_ITENS = 'itens';

export const listaNoPlanner = (aj: Ajustes | undefined, aba: AbaId, lista: string) => !!aj?.noPlanner?.[aba]?.includes(lista);

export function enviarListaAoPlanner(aba: AbaId, lista: string, enviar: boolean) {
  setDoc('ajustes', d => {
    const atual = new Set(d.noPlanner?.[aba] ?? []);
    if (enviar) atual.add(lista); else atual.delete(lista);
    return { ...d, noPlanner: { ...(d.noPlanner ?? {}), [aba]: [...atual] } };
  });
}

export function useListaNoPlanner(aba: AbaId, lista: string) {
  const aj = useDoc('ajustes');
  return listaNoPlanner(aj, aba, lista);
}
